import axios from "axios";
import { PanssParameters } from "../types/PanssParameters.type";
import { PanssResult } from "../types/PanssResults.type";
import { getServerUrl } from './getServerUrl';

export async function predictPanss(panss:PanssParameters) {
    const URL = getServerUrl()+"/randomforest/predict";
    console.log(URL);
    //const URL = "https://permepsy-dev.cs.upc.edu/randomforest/predict";
    const storedToken = localStorage.getItem("authToken");
    const response = await axios.post<PanssResult>(
        URL,
        {
            headers: {
                "Authorization": "Bearer " + storedToken,
                "Content-Type": "application/json",
            },
            pred_data: panss,
            
        }
    );
    return response.data
}
